import { ref } from '@vue/composition-api'

export const cellRendererBoolean = params => {
  return params.value
    ? '<i class="fas fa-check-circle grid-icon-font grid-icon-green"></i>'
    : '<i class="fas fa-times-circle grid-icon-font grid-icon-red"></i>'
}

export const arPrepaymentsColumns = [
  { headerName: 'Client Name', field: 'client.name' },
  { headerName: 'Client Code', field: 'client.short_name' },
  { headerName: 'ST', field: 'attached_sale.id' },
  { headerName: 'ST Status', field: 'attached_sale.status.status' },
  { headerName: 'Date', field: 'payment_date' },
  { headerName: 'Amount', field: 'amount' },
  { headerName: 'Type', field: 'type' },
  { headerName: 'Check #', field: 'check_number' },
  { headerName: 'Reference', field: 'reference' },
  { headerName: 'Posted', field: 'posted', cellRenderer: cellRendererBoolean },
  { headerName: 'Voided', field: 'voided', cellRenderer: cellRendererBoolean },
  { headerName: 'Void Comments', field: 'void_comments' },
  { headerName: 'REP', field: 'attached_sale.rep.initials' },
  { headerName: 'Cash Account', field: 'account.number' },
  { headerName: 'Currency', field: 'currency' },
  { headerName: 'Journal Code', field: 'attached_journal.code' }
]

export function UseAgGridReady () {
  const gridApi = ref(null)
  const columnApi = ref(null)

  function gridReady (params) {
    gridApi.value = params.api
    columnApi.value = params.columnApi
  }

  return {
    gridApi,
    columnApi,
    gridReady
  }
}
